<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card :loading="loading">
        <div slot="title"><a-icon type="file-search" />&nbsp; Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse activeKey="1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-date-picker
                    placeholder="Select Date"
                    v-model="searchDate"
                    format="DD-MMM-YYYY"
                    allowClear
                  />
                </div>
                <div class="m-form-item-wrapper">
                  <label for="kategori">Category</label>
                  <a-select
                    placeholder="Ex: Avionik ... "
                    v-model="kategori"
                    class="width-full"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in getSupplierType"
                      :key="item.id"
                      :value="item.value"
                      >{{ item.label }}</a-select-option
                    >
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label for="rating">Rating</label>
                  <a-select
                    placeholder="Choose Rating "
                    v-model="rating"
                    class="width-full"
                    allowClear
                  >
                    <a-select-option  :key="1" value="obj.rating_value >12">
                      <Rating :rating="'12'" />
                    </a-select-option>
                    <a-select-option  :key="2" value="obj.rating_value  < 12 && obj.rating_value  >= 9">
                      <Rating :rating="'9'" />
                    </a-select-option>
                    <a-select-option  :key="3" value="obj.rating_value  < 9 && obj.rating_value  >= 6">
                      <Rating :rating="'6'" />
                    </a-select-option>
                    <a-select-option  :key="4" value="obj.rating_value  < 6 && obj.rating_value  >= 3">
                      <Rating :rating="'3'" />
                    </a-select-option>
                    <a-select-option  :key="5" value="obj.rating_value  < 3 || isNaN(obj.rating_value)">
                      <Rating :rating="'1'" />
                    </a-select-option>
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Status</label>
                  <a-select
                    placeholder="Ex: Approved ... "
                    v-model="status"
                    class="width-full"
                    initialValue="delivered"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in getStatus"
                      :key="item.id"
                      :value="item.value"
                      >{{ item.label }}</a-select-option
                    >
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList
        :loading="loading"
        title="Supplier List"
        :printlist = printlist
        :createLink="'create'+menutype"
        :disabledCreateEditLink="isPuchasingOrGA"
        :manifestLink="linkmanifest"
        :editLink="'edit'+menutype"
        :dataList="searching"
        :rating="true"
      />
    </a-col>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import Axios from "axios";
import moment from "moment";
import Rating from "@/components/Rating.vue";

export default {
  name: "Supplier",
  components: {
    Rating,
  },
  data() {
    return {
      loading: true,
      purchasingList: [],
      storeList: [],
      search: "",
      searchDate: null,
      status: undefined,
      kategori: undefined,
      rating: undefined,
      pagination: {
        pageSize: 5,
        size: "small",
      },
      printlist: {
        status: true,
        tooltips:"Print List Data Only 3 Start Above!",
        url: this.$serviceUrl + "suplier/cetak_list_suplier",
      },
    };
  },
  computed: {
    ...mapGetters(["getScreen", "getAuth", "getSupplierType", "getStatus"]),
    searching() {
      let output = this.purchasingList;

      if (this.search) {
        output = output.filter(
          (obj) =>
            obj.title &&
            obj.title.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (this.kategori) {
        let filterKategori = this.kategori;
        output = output.filter(
          (objDt) =>
            objDt.kategori &&
            objDt.kategori.toLowerCase() === filterKategori.toLowerCase()
        );
      }

      if (this.status) {
        output = output.filter(
          (obj) =>
            obj.status &&
            obj.status.toLowerCase().indexOf(this.status.toLowerCase()) >= 0
        );
      }

      if (this.searchDate) {
        let searchDate = moment(this.searchDate).format("YYYY-MM-DD");
        output = output.filter((obj) => obj.tanggal === searchDate);
      }

      if(this.rating){
        eval("output = output.filter((obj) => "+this.rating+");");
      }

      return output;
    },
    isPuchasingOrGA(){
      return !((this.getAuth.divisi[0] && this.getAuth.divisi[0].toLowerCase()=="purchasing") ||
        (this.getAuth.divisi[0] && this.getAuth.divisi[0].toLowerCase()=="general affair"));
    },
    menutype(){
      let key = localStorage.getItem("nvky");
      if (key==47){
        return 'Purchasing';
      }else if(key==73){
        return 'PurchasingGA';
      }else if(key==15 || key==276){
        return 'PurchasingKeu';
      }else if(key==145){
        return 'SpclSupplierFin';
      }else{
        return '';
      }
    },
    linkmanifest(){
      if (this.menutype =='PurchasingKeu'){
        return 'SpclSupplierManifestKeu';
      } 
        return 'manifest'+this.menutype;
    },
  },
  methods: {
    fetchPurchasing() {
      Axios({
        method: "get",
        url: this.$serviceUrl + "suplier",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.storeList = response.data.data;
          response.data.data.forEach((data) => {
            this.purchasingList.push({
              title: data.nama_perusahaan,
              subdesc: [data.jenis_produk],
              status: data.status,
              id: data.id_supplier,
              rating_value:
                data.nilai_evaluasi === "0"
                  ? data.total_score
                  : data.nilai_evaluasi,
              kategori: data.kategori,
              tanggal: data.tanggal,
              dataFor: 'supplier'
            });
          });
          this.loading = false;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
  },
  mounted() {
    this.fetchPurchasing();
  },
};
</script>

<style>
</style>